import React from 'react';
import { Form } from 'react-bootstrap';

export function ExperimentalSection({ item }) {
  const {
    hideCardDetails,
    dynamicBranchRendering,
    nodeEditSidePanel,
    onHideCardDetailsChange,
    onDynamicBranchRenderingChange,
    onNodeEditSidePanelChange,
  } = item;

  return (
    <div className="pt-4 mt-4 border-top">
      <h6 className="text-muted mb-3">Experimental</h6>
      <Form.Group controlId="experimental-hide-card-details" className="mb-2">
        <Form.Check
          custom
          type="switch"
          id="experimental-hide-card-details"
          label="Hide Card Details"
          checked={hideCardDetails}
          onChange={(e) => onHideCardDetailsChange?.(e.target.checked)}
        />
      </Form.Group>
      <Form.Group controlId="experimental-dynamic-branch-rendering" className="mb-2">
        <Form.Check
          custom
          type="switch"
          id="experimental-dynamic-branch-rendering"
          label="Dynamic Rendering"
          checked={dynamicBranchRendering}
          onChange={(e) => onDynamicBranchRenderingChange?.(e.target.checked)}
        />
      </Form.Group>
      <Form.Group controlId="experimental-node-edit-side-panel" className="mb-2">
        <Form.Check
          custom
          type="switch"
          id="experimental-node-edit-side-panel"
          label="Side-by-Side Editor"
          checked={nodeEditSidePanel}
          onChange={(e) => onNodeEditSidePanelChange?.(e.target.checked)}
        />
      </Form.Group>
    </div>
  );
}
